import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '/app/environments/environment';
import { LastPosicionResponse } from '/app/mapaRiesgo/models/lastposicion';
import { EMPTY } from 'rxjs';
import { expand, reduce } from 'rxjs/operators';







@Injectable({
  providedIn: 'root'
})
export class LastposicionService {

  constructor(private httpClient: HttpClient) { }

  public getMonitors() {
    return this.httpClient.get(environment.api + '/monitors');
  }

  /**
   * Consulta la última posición.
   * Si se proporciona monitorId, consulta por monitor.
   * Si no, usa el rango de fechas indicado.
   */
  // public getLastPosition(
  //   monitorId?: string,
  //   dateRangePreset: string = 'LAST_24_HOURS'
  // ) {

  //   let params: HttpParams;

  //   if (monitorId) {
  //     params = new HttpParams()
  //       .set('monitorId', monitorId);
  //   } else {
  //     params = new HttpParams()
  //       .set('dateRangePreset', dateRangePreset);
  //   }

  //   return this.httpClient.get<LastPosicionResponse>(
  //     `${environment.api}/ingest/last-position`,
  //     { params }
  //   );
  // }

  public getLastPosition(monitorId: string) {
    const params = new HttpParams()
      .set('page', '0')
      .set('size', '100')
      .set('status', '*')
      .set('latestPerAsset', 'true');

    return this.httpClient.get<any>(
      `${environment.api}/alarms/${monitorId}/monitor`,
      { params }
    );
  }


  // public getLastPosition(
  //   monitorId: string,
  //   size: number = 100,
  //   status: string = '*',
  //   latestPerAsset: boolean = true
  // ) {
  //   const getPage = (page: number) => {
  //     const params = new HttpParams()
  //       .set('page', page.toString())
  //       .set('size', size.toString())
  //       .set('status', status)
  //       .set('latestPerAsset', latestPerAsset.toString());

  //     return this.httpClient.get<any>(
  //       `${environment.api}/alarms/${monitorId}/monitor`,
  //       { params }
  //     );
  //   };

  //   return getPage(0).pipe(
  //     expand(response => {
  //       // Si la página viene llena, puede existir otra
  //       if (response.content.length === size) {
  //         return getPage(response.number + 1);
  //       }

  //       // Termina la paginación
  //       return EMPTY;
  //     }),
  //     reduce((all, response) => {
  //       return {
  //         ...response,
  //         content: [...all.content, ...response.content]
  //       };
  //     }, {
  //       content: []
  //     })
  //   );
  // }




  public getAlarmsForMonitor(
    monitorId: string,
    status: string = '*',
    latestPerAsset: boolean = true
  ) {

    const getPage = (page: number) => {
      const params = new HttpParams()
        .set('page', page.toString())
        .set('size', '100')
        .set('status', status)
        .set('latestPerAsset', latestPerAsset.toString());

      return this.httpClient.get<any[]>(
        `${environment.api}/alarms/${monitorId}/monitor`,
        { params }
      );
    };

    let currentPage = 0;

    return getPage(currentPage).pipe(
      expand((response) => {
        currentPage++;

        return response.length === 100
          ? getPage(currentPage)
          : EMPTY;
      }),

      reduce<any[], any[]>(
        (allResults, currentPage) => [
          ...allResults,
          ...currentPage
        ],
        []
      )
    );
  }
}







